import axios from "axios";

export default {
  getKPIData(year, month = null) {
    const params = { year };
    if (month !== null) {
      params.month = month;
    }
    return axios.get("/api/kpi/statistics", {
      params,
    });
  },
  /**
   * Exporte les provisions en PDF avec données pré-calculées.
   * @param {Object} provisionData - Données des provisions (ProvisionExportDto)
   * @param {number} provisionData.year - Année du rapport
   * @param {number} provisionData.totalPointsProjected - Total des points projetés
   * @param {number} provisionData.totalCost - Total des coûts
   * @param {Array} provisionData.franchises - Liste des franchises avec leurs données
   * @returns {Promise<Blob>} Fichier PDF
   */
  exportProvisionsToPdf(provisionData) {
    return axios.post("/api/kpi/provisions/export", provisionData, {
      responseType: "blob",
    });
  },
  getKPIFranchiseData(year, month = null) {
    const params = { year };
    if (month !== null) {
      params.month = month;
    }
    return axios.get("/api/kpi/statistics-franchise", {
      params,
    });
  },
  getKPICustomerData(year, month = null) {
    const params = { year };
    if (month !== null) {
      params.month = month;
    }
    return axios.get("/api/kpi/statistics-customer", {
      params,
    });
  },
  getKPIProvisionData(year, month = null) {
    const params = { year };
    if (month !== null) {
      params.month = month;
    }
    return axios.get("/api/kpi/provisions", {
      params,
    });
  },
  getOrderOneStrykerKPIData(data) {
    if (data) {
      return axios.get(`api/kpi/orders-details${data.text}`);
    } else {
      return axios.get("api/kpi/orders-details");
    }
  },
  getGimCustomsDistribution() {
    return axios.get("/api/kpi/gimcustoms/distribution");
  },
  getKPICommissions(year = null) {
    const params = {};
    if (year !== null) {
      params.year = year;
    }
    return axios.get("/api/kpi/customer-purchases-by-group", {
      params,
    });
  },
  getKPIConfiguration(configurations, year = null, month = null) {
    var paramsToSend = "";
    if (Array.isArray(configurations)) {
      configurations.forEach((element, index) => {
        paramsToSend += `names=${element}`;
        // Ajoute '&' uniquement si ce n'est pas le dernier élément
        if (index < configurations.length - 1) {
          paramsToSend += "&";
        }
      });
    } else {
      paramsToSend = `names=${configurations}`;
    }

    // Ajout des paramètres year et month si présents
    if (year !== null) {
      paramsToSend += `&year=${year}`;
    }
    if (month !== null) {
      paramsToSend += `&month=${month}`;
    }

    return axios.get(`/api/kpi/by-names?${paramsToSend}`);
  },
  updateManualCogs(data) {
    return axios.put("/api/kpi/manual-cogs", data);
  },
  updateKpiData(data) {
    return axios.put("/api/kpi/kpi-key", data);
  },
  exportExcelCommissions(year = null) {
    const params = {};
    if (year !== null) {
      params.year = year;
    }
    return axios.get("/api/kpi/customer-purchases-by-group/export", {
      params,
      responseType: "blob",
    });
  },
  exportExcelFranchise(year, month = null) {
    const params = { year };
    if (month !== null) {
      params.month = month;
    }
    return axios.get("/api/kpi/statistics-franchise/export", {
      params,
      responseType: "blob",
    });
  },
  exportExcelCustomer(year, month = null) {
    const params = { year };
    if (month !== null) {
      params.month = month;
    }
    return axios.get("/api/kpi/statistics-customer/export", {
      params,
      responseType: "blob",
    });
  },
  exportExcelOrderOne(data) {
    const params = new URLSearchParams();
    if (
      data.contractYear !== null &&
      data.contractYear !== "" &&
      data.contractYear !== undefined
    ) {
      params.append("ContractYear", data.contractYear);
    }
    if (
      data.customerID !== null &&
      data.customerID !== "" &&
      data.customerID !== undefined
    ) {
      params.append("CustomerId", data.customerID);
    }
    if (data.orderNumber !== null && data.orderNumber !== undefined) {
      params.append("OrderNumber", data.orderNumber);
    }
    if (data.productReference !== null && data.productReference !== undefined) {
      params.append("ProductReference", data.productReference);
    }
    if (data.startDate !== null && data.startDate !== undefined) {
      params.append("StartDate", data.startDate);
    }
    if (data.endDate !== null && data.endDate !== undefined) {
      params.append("EndDate", data.endDate);
    }
    if (data.search !== null && data.search !== undefined) {
      params.append("Search", data.search);
    }
    if (data.orderBy !== null && data.orderBy !== undefined) {
      params.append("OrderBy", data.orderBy);
    }

    return axios.get(`/api/kpi/orders-details/export`, {
      params: params,
      responseType: "blob",
    });
  },
};
